import axios, { AxiosError, AxiosInstance } from "axios";

import * as process from "process";

export const baseUrl = process.env.REACT_APP_SECOND_API_URL;
export const secondUploadBaseUrl = process.env.REACT_APP_SECOND_UPLOAD_URL;

class AxiosBase {
  base: AxiosInstance;
  constructor() {
    this.base = axios.create({
      baseURL: baseUrl,
      // headers: {
      //     "Authorization": "Bearer " + localStorage.getItem("token")
      // },
      // withCredentials: true
    });

    this.base.interceptors.request.use(
      async (config) => {
        // Dispatch setLoading action with loading set to true
        // store.dispatch(setLoading({ isLoading: true }));
        // store.dispatch(setStatus({ status: 'working' }));
        //config.headers['Origin'] = 'http://localhost:3000';

        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
    this.base.interceptors.response.use(
      (response: any) => {
        // store.dispatch(setStatus({ status: 'done' }));
        // store.dispatch(setLoading({ isLoading: false }));

        return response;
      },
      (error: AxiosError) => {
        if (error.code === "ERR_CANCELED") return Promise.reject(error);
        // Handle errors globally

        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          // store.dispatch(setStatus({ status: 'error' }));
          // store.dispatch(setLoading({ isLoading: false }));

          if (error.response.status === 404) {
            // @ts-ignore
            // store.dispatch(logoutUser())
            //window.location.href = "/login"
            return Promise.reject({ error: "not found" });
          } else {
            return Promise.reject({ error: true });
          }
        } else if (error.request) {
          // The request was made but no response was received
          console.error("Request error:", error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.error("Error message:", error.message);
        }

        return Promise.reject(error);
      }
    );
  }
}

const base = new AxiosBase();
export default base;
